import { Button, message, Switch, Table } from "antd";
import React, { useState } from "react";
import VariablesViewModal from "./variables/VariablesViewModal";

function MasterSuiteViewTable(props) {
  const [variableModalOpen, setVariableModalOpen] = useState(false);
  const [currentVariable, setCurrentVariable] = useState();
  const columns = [
    {
      title: "",
      dataIndex: "sequence",
      key: "sequence",
      width: "2%",
      align: "center",
    },
    {
      title: "Step Name",
      dataIndex: "stepReference",
      key: "stepReference",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      responsive: ["md"],
      render: (_, record) => (
        <p>{record.type === "masterSuite" ? "Master Suite" : "Task"}</p>
      ),
      width: "10%",
    },
    {
      title: "Category",
      dataIndex: "categoryValue",
      key: "category",
      width: "15%",
    },
    {
      title: "Sub Category",
      dataIndex: "subCategoryValue",
      key: "subcategory",
      responsive: ["lg"],
    },
    {
      title: "Task/Suite Name",
      dataIndex: "taskName",
      key: "taskName",
      width: "20%",
    },
    {
      title: "Parameters",
      dataIndex: "variables",
      key: "variables",
      align: "center",
      responsive: ["md"],
      render: (_, record) => (
        <Button type="link" onClick={() => handleVariableModal(record)}>
          View
        </Button>
      ),
      width: "10%",
    },
    {
      title: "Stop if Failed",
      dataIndex: "stopIfFailed",
      key: "stopIfFailed",
      responsive: ["md"],
      render: (_, record) => (
        <Switch
          className="custom-switch"
          checked={record.stopIfFailed}
          checkedChildren="ON"
          unCheckedChildren="OFF"
        />
      ),
      align: "center",
    },
  ];

  const handleVariableModal = (record) => {
    if (record.variables === null) {
      message.error("No variables configured for this step");
      return;
    }
    setCurrentVariable(record.variables);
    setVariableModalOpen(!variableModalOpen);
  };
  const getRowClassName = (record) => {
    const { variables } = record;

    if (
      variables?.defaultEnvironmentOne &&
      variables.environmentOne !== props.environment
    ) {
      return "row-different-environment";
    }

    if (
      variables?.defaultEnvironmentTwo &&
      variables.environmentTwo !== props.environment
    ) {
      return "row-different-environment";
    }

    return "";
  };

  return (
    <div>
      <Table
        columns={columns}
        dataSource={props.dataSource}
        rowClassName={getRowClassName}
      />
      <VariablesViewModal
        open={variableModalOpen}
        handleVariableModal={handleVariableModal}
        record={currentVariable || {}}
      />
    </div>
  );
}

export default MasterSuiteViewTable;
